<template>
    <v-dialog v-model="modal" :scrim="false" width="900">
        <v-card>
            <component :is="`extra-service-card${$breakpoint.smAndDown ? '-mobile' : ''}`" :product="entry">
                <template v-slot:price="{offer}">
                    <tour-offer-delta-button :offer="offer" :offer-key="offerKey" :entry-name="entry.entryName" />
                </template>
            </component>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_EXTRA_SERVICE_INFO} from '@/utils/event-bus'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import ExtraServiceCard from '@/components/extraServices/search/offers/ExtraServiceCard.vue'
    import ExtraServiceCardMobile from '@/components/extraServices/search/offers/ExtraServiceCardMobile.vue'

    @Component({
        components: {
            TourOfferDeltaButton,
            ExtraServiceCard,
            ExtraServiceCardMobile,
        },
    })
    export class TourExtraServiceInfoModal extends Vue {
        @Prop({required: true}) searchRequest

        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_EXTRA_SERVICE_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_EXTRA_SERVICE_INFO, this.showModal)
        }

        async showModal({entry, offerKey}) {
            try {
                const info = await this.$api.ownExtraServiceInfo.get({offerKey: entry.offers[0].offerKey})
                this.entry = {
                    ...entry,
                    info: {
                        name: info.productName,
                        description: info.productDescription ? info.productDescription : '',
                        imageUrl: info.images.find(item => item.mainImage).url || info.images[0].url,
                    },
                }
                this.offerKey = offerKey
                this.modal = true
            } catch (e) {
                this.entry = {}
                this.offerKey = null
                this.modal = false
            }
        }

        get component() {
            return this.$breakpoint.smAndDown
                ? resolveComponent('ExtraServiceCardMobile')
                : resolveComponent('ExtraServiceCard')
        }
    }

    export default TourExtraServiceInfoModal
</script>
